import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { School } from '@tanzspass/shared';
import { SchoolService } from '../../services/school.service';
// import { Map, LngLat } from 'mapbox-gl';

@Component({
  selector: 'ts-school-contact',
  templateUrl: './school-contact.component.html',
  styleUrls: ['./school-contact.component.css'],
  imports: [MatIcon, NgIf],
})
export class SchoolContactComponent implements OnInit {
  public school: School = new School();
  // public position: LngLat;
  // map: Map;

  constructor(private schoolSrv: SchoolService) {}

  /*public updateMap($event) {
    this.map = $event;
    this.map.setCenter(this.position);
  }*/

  ngOnInit() {
    this.schoolSrv.current().subscribe((school) => {
      Object.assign(this.school, school);
      // this.position = new LngLat(this.school.lng, this.school.lat);
    });
  }
}
